import { render, staticRenderFns } from "./processSetView.vue?vue&type=template&id=c20ac054&scoped=true&"
import script from "./processSetView.vue?vue&type=script&lang=js&"
export * from "./processSetView.vue?vue&type=script&lang=js&"
import style0 from "./processSetView.vue?vue&type=style&index=0&id=c20ac054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ac054",
  null
  
)

export default component.exports